/**
 * Durations and easings.
 *
 * Anything a person triggered should land in `fast`; `slow` is for something arriving on its own
 * that they did not ask for and should not have to wait through. `stage` is one beat of the hero's
 * load sequence, where lab markers draw into a formula. Its delays are multiples of this beat, so
 * retiming the sequence is one value.
 *
 * `standard` decelerates: it leaves quickly and settles, which is how a moved object behaves. A
 * symmetric ease on an element that is arriving reads as hesitant.
 *
 * In the signed-in app, `fast` is hover, press and colour changes, `medium` is a popover or menu
 * opening, and `slow` is a sheet or dialog opening. Something leaving uses `exit` at 70% of the
 * duration it arrived with, because a person waits for an arrival and never for a departure.
 *
 * A tooltip opens 500ms after the pointer settles, then opens at once for any other tooltip
 * reached within 300ms, so scanning a row of icons is not a wait at each one. Those are timers in
 * script rather than CSS values, so they are not variables here.
 *
 * Under `prefers-reduced-motion: reduce` a transform becomes an opacity change of `fast`, or
 * nothing.
 */
import * as stylex from "@stylexjs/stylex";
export const motion = {
  fast: "var(--x11gf7eo)",
  medium: "var(--x1984wfr)",
  slow: "var(--x1uw7nx8)",
  stage: "var(--x1guwu5m)",
  standard: "var(--x83mddk)",
  entrance: "var(--x10sqo1w)",
  exit: "var(--x18ax5av)",
  __varGroupHash__: "x17muy3b"
};